/* eslint-disable import/no-duplicates */
import { formatWithOptions, parseISO } from 'date-fns/fp';
import ru from 'date-fns/locale/ru';

const formatRu = formatWithOptions({ locale: ru });

export const formatMonth = formatRu('MMMM');

export const formattingMonth = (date: string) => formatMonth(parseISO(date)) + ' ' + new Date(date).getFullYear();
